<template>
  <div
    class="card statistics-card"
    :class="{ 'is-shadow': isShadow }"
    :style="{ height: height || 'auto' }"
  >
    <div class="flex statistics-card__head">
      <div class="flex row-center count-image">
        <!-- <i class="iconfont" :class="topInfo.icon"></i> -->
        <el-image
          style="width: 100%; height: 100%"
          :src="topInfo.icon"
          fit="contain"
        />
      </div>
      <div class="flex-1 count-item">
        <div class="count-item__text">
          {{ topInfo.label || '-' }}
          <el-popover
            v-if="topInfo.tip"
            placement="top"
            width="200"
            trigger="hover"
            :content="topInfo.tip"
          >
            <i slot="reference" class="iconfont icon-help"></i>
          </el-popover>
        </div>
        <div class="count-item__num" :class="{'clickable': topInfo.isClickable }" @click="handleClick(topInfo)">
          {{
            topInfo.isNumber
              ? topInfo.value.toString()
                ? strToThousands(topInfo.value)
                : '-'
              : topInfo.value
          }}
        </div>
      </div>
    </div>
    <el-divider class="m-t-20 m-b-20" />
    <div class="flex statistics-card__foot">
      <div
        v-for="(item, index) in footList"
        :key="index"
        class="flex-1 count-item"
      >
        <div class="count-item__text">
          {{ item.label }}
          <el-popover
            v-if="item.tip"
            placement="top"
            width="200"
            trigger="hover"
            :content="item.tip"
          >
            <i slot="reference" class="iconfont icon-help"></i>
          </el-popover>
        </div>
        <div class="count-item__num" :class="{'clickable': item.isClickable }" @click="handleClick(item)">
          {{
            item.isNumber
              ? item.value.toString()
                ? strToThousands(item.value)
                : '-'
              : item.value
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { strToThousands } from '@/utils/utils'
export default {
  props: {
    // card是否有阴影
    isShadow: {
      type: Boolean,
      default: false
    },
    infoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {}
  },

  computed: {
    topInfo() {
      return this.infoList.find(item => item.isTop) || this.infoList[0] || {}
    },

    footList() {
      return this.infoList.filter(item => !item.isTop)
    }
  },

  methods: {
    strToThousands,

    handleClick(item) {
      if (item.isClickable) {
        this.$emit('jump', item)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-card {
  padding: 20px 24px;

  &.is-shadow {
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  &__head {
    .count-image {
      flex: 0 0 56px;
      width: 56px;
      height: 56px;
      margin-right: 20px;
      overflow: hidden;
      // background-color: $primary-third-color;
      // font-size: 30px;

      // .iconfont {
      //   color: $primary-color;
      //   font-size: 32px;
      // }
    }

    .count-item {
      &__text {
        font-size: 14px;
        line-height: 20px;
        // color: $second-text-color;
        color: rgba(0,0,0,0.45);
      }

      &__num {
        margin-top: 4px;
        font-size: 24px;
        @include text-bold;
        line-height: 32px;
        // color: $text-color;
        color: rgba(0,0,0,0.85);
        font-weight: 800;
      }
    }
  }

  ::v-deep .el-divider {
    background-color: #E8E8E8;
  }

  &__foot {
    .count-item {
      &__text {
        font-size: 14px;
        line-height: 20px;
        // color: $third-text-color;
        color: rgba(0,0,0,0.65);
      }

      &__num {
        margin-top: 2px;
        font-size: 16px;
        @include text-bold;
        line-height: 22px;
        // color: $second-text-color;
        color: rgba(0,0,0,0.85);
      }
    }
  }
}
</style>
